module.exports = __webpack_public_path__ + "img/2012-08-18 10.53.31.6d726c04.jpg";